window.clickOutsideHandler = {
    eventListeners: {},
    addEvent: function (elementId, dotnetHelper) {
        if (this.eventListeners[elementId]) {
            this.removeEvent(elementId);
            console.warn("Multiple outside click handlers registered with same element id: " + elementId);
        }
        
        this.eventListeners[elementId] = function(e) {
            if (!document.getElementById(elementId).contains(e.target)) {
                dotnetHelper?.invokeMethodAsync("InvokeClickOutside");
            }
        }
        
        window.addEventListener("mousedown", this.eventListeners[elementId]);
    },
    removeEvent: function(elementId) {
        window.removeEventListener("mousedown", this.eventListeners[elementId]);
        delete this.eventListeners[elementId];
    }
};